import { render, staticRenderFns } from "./UpdateOrderInstructionsModal.vue?vue&type=template&id=677f73de"
import script from "./UpdateOrderInstructionsModal.vue?vue&type=script&lang=ts"
export * from "./UpdateOrderInstructionsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports